<template>
  <base-dialog width="485px" class="update-role-dialog" :visible.sync="visible" show-close>
    <template v-slot:header>
      更换负责角色
    </template>
    <el-form>
      <el-form-item label="设置新角色" label-width="100px">
        <el-select v-model="assigneeRole" clearable filterable placeholder="请选择">
          <el-option
            v-for="(item, index) in roleList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import UserSelector from "@/components/FormControl/UserSelector"
import {getAllProjectRole} from "@/api/project/project";
export default {
  name: "UpdateRoleDialog",
  components: { BaseButton, BaseDialog },
  props: {
    projectId: String
  },
  data() {
    return {
      visible: false,
      assigneeRole: "",
      roleList: []
    }
  },
  created() {
    getAllProjectRole(this.projectId).then(roleList => (this.roleList = roleList))
  },
  methods: {
    open() {
      this.visible = true
      this.assigneeRole = ""
    },
    submit() {
      this.$emit("select", { roleId: this.assigneeRole })
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.update-role-dialog {
  .el-form {
    margin-top: 30px;
    ::v-deep {
      .el-form-item {
        .el-form-item__label {
          text-align: left;
        }
        .el-form-item__content {
          display: flex;
          .el-select {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>
